/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Optional filters to narrow criteria to specific entities
 * @export
 * @interface StreakCriteriaFilters
 */
export interface StreakCriteriaFilters {
    /**
     * 
     * @type {Array<string>}
     * @memberof StreakCriteriaFilters
     */
    questConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StreakCriteriaFilters
     */
    activationIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StreakCriteriaFilters
     */
    surfaceIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StreakCriteriaFilters
     */
    gameIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StreakCriteriaFilters
     */
    competitionIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StreakCriteriaFilters
     */
    brandIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StreakCriteriaFilters
     */
    rewardTypes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StreakCriteriaFilters
     */
    eventTypeIds?: Array<string>;
    /**
     * For CLIP_SHARED — match against entityId. Values are SharePlatform enum members (e.g. "TWITTER", "DISCORD") or the "PUBLIC" sentinel for the privacy-flip path. Empty/absent => any clip share matches.
     * @type {Array<string>}
     * @memberof StreakCriteriaFilters
     */
    clipShareTargets?: Array<string>;
}

/**
 * Check if a given object implements the StreakCriteriaFilters interface.
 */
export function instanceOfStreakCriteriaFilters(value: object): value is StreakCriteriaFilters {
    return true;
}

export function StreakCriteriaFiltersFromJSON(json: any): StreakCriteriaFilters {
    return StreakCriteriaFiltersFromJSONTyped(json, false);
}

export function StreakCriteriaFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakCriteriaFilters {
    if (json == null) {
        return json;
    }
    return {
        
        'questConfigIds': json['questConfigIds'] == null ? undefined : json['questConfigIds'],
        'activationIds': json['activationIds'] == null ? undefined : json['activationIds'],
        'surfaceIds': json['surfaceIds'] == null ? undefined : json['surfaceIds'],
        'gameIds': json['gameIds'] == null ? undefined : json['gameIds'],
        'competitionIds': json['competitionIds'] == null ? undefined : json['competitionIds'],
        'brandIds': json['brandIds'] == null ? undefined : json['brandIds'],
        'rewardTypes': json['rewardTypes'] == null ? undefined : json['rewardTypes'],
        'eventTypeIds': json['eventTypeIds'] == null ? undefined : json['eventTypeIds'],
        'clipShareTargets': json['clipShareTargets'] == null ? undefined : json['clipShareTargets'],
    };
}

export function StreakCriteriaFiltersToJSON(json: any): StreakCriteriaFilters {
    return StreakCriteriaFiltersToJSONTyped(json, false);
}

export function StreakCriteriaFiltersToJSONTyped(value?: StreakCriteriaFilters | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questConfigIds': value['questConfigIds'],
        'activationIds': value['activationIds'],
        'surfaceIds': value['surfaceIds'],
        'gameIds': value['gameIds'],
        'competitionIds': value['competitionIds'],
        'brandIds': value['brandIds'],
        'rewardTypes': value['rewardTypes'],
        'eventTypeIds': value['eventTypeIds'],
        'clipShareTargets': value['clipShareTargets'],
    };
}

